import{installAutoSignalTracking as r}from"@preact/signals-react/runtime";r();//# sourceMappingURL=auto.module.js.map
